__webpack_require__.p = "https://admin-skoolas.shaktavisi.com/";